module.exports = __webpack_public_path__ + "static/img/circle_icon.757de891.png";